<template>
  <v-responsive class="overflow-y-auto" :max-height="$store.state.maxHeight">
  <v-row>
    <v-col
      v-for="(img,index) in imgList"
      :key="index"
      class="d-flex child-flex"
      cols="12"
      md="2"
      sm="2"
    >
      <v-card flat tile class="d-flex">
        <photo-card :img="img" :index="index"></photo-card>
      </v-card>
    </v-col>
  </v-row>
</v-responsive>
</template>
<style></style>
<script>

  import PhotoCard from "../../components/pic/photo-card";
  export default {
    components: {PhotoCard},
    data () {
      return {
      }
    },
    computed:{
      imgList(){
        let imgListArr = [];
        for(let i=0;i<71;i++){
          imgListArr.push("../../../static/video/img"+(i+1)+".jpg");
        }
        return imgListArr;
      }
    },
    methods: {
        imgSrc(n){
            // return "../../../static/img/dabai.jpg";
            return "https://picsum.photos/500/300?image="+n;
        },
    },
    mounted(){

    }

  }
</script>



// WEBPACK FOOTER //
// src/page/plot/plot-pic.vue